import Repository from "../../repository";

export default {
    Register: (payload) => Repository.post(`/api/CustomerNoAuth/Register`, payload),
}
